import { render, staticRenderFns } from "./BookingFormFields.vue?vue&type=template&id=065e3d6e&"
import script from "./BookingFormFields.vue?vue&type=script&lang=js&"
export * from "./BookingFormFields.vue?vue&type=script&lang=js&"
import style0 from "./BookingFormFields.vue?vue&type=style&index=0&id=065e3d6e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports